<template>
  <div class="separator ">
    <div style="display: flex;">
      <div style="display: flex;">
        <div @click="time_btn(item.value)" class="separator_left "
             :class="{ 'separator_left_max': form.date_value === item.value }" v-for="(item, index) in time_list"
             :key="index">{{ item.name }}
        </div>
      </div>
      <TimeyellowS v-if=" form.date_value ==0" :pickerTime.sync="pickerTime"/>
      <TimeyellowNS v-if=" form.date_value !=0" :pickerTime.sync="pickerTime"/>
    </div>

    <div class="riht_box">
      <NowTime class="time_box"/>
      <img class="separator_r" src="../../../assets/menu-r.png" alt="">
    </div>
  </div>
</template>

<script>
import NowTime from '@/components/nowTime'
import TimeyellowS from '@/components/time/time_yellow_s'
import TimeyellowNS from '@/components/time/time_yellow_ns'

export default {
  components: {
    NowTime, TimeyellowS, TimeyellowNS
  },
  props: {
    form: {
      type: Object,
      default: {}
    },
    sendMessage: {
      type: Function,
      default: () => {
      }
    }
  },
  data() {
    return {
      pickerTime: [],
      time_list: [
        {
          name: '今日',
          value: 1
        },
        {
          name: '昨日',
          value: 2
        },
        {
          name: '本月',
          value: 3
        },
        {
          name: '上月',
          value: 4
        },
      ],
    }
  },
  watch: {},
  methods: {
    time_btn(val) {
      this.$emit('update:form', {
        ...this.form,
        date_start:'',
        date_end: '',
        date_type: 0,
        date_value: val,
      });
      this.sendMessage()
      this.pickerTime=[]
    },
    pickerTime_change(time1, time2) {
      this.$emit('update:form', {
        ...this.form,
        date_start:time1,
        date_end: time2,
        date_type: 1,
        date_value: 0
      });
      this.sendMessage()
    },
  }

}
</script>

<style lang="scss" scoped>
::v-deep .el-range-input {
  color: #00A8FF;
  background: #0f2953;
}

::v-deep .el-range-separator {
  color: #00A8FF;
}

::v-deep .el-range__close-icon {
  color: #00A8FF;
}

::v-deep .el-picker-panel {
  background-color: #2c629f !important;
}

.separator {
  display: flex;
  justify-content: space-between;
  // background-color: #0C70A4;
  width: 100%;
  height: 36px;

  .riht_box {
    display: flex;
    align-items: center;
    gap: 20px;


    .time_box {
      width: 480px;
    }

    .separator_r {
      width: 26px;
      height: 26px;
    }

  }

}


.separator_left {
  cursor: pointer;
  margin-right: 14px;
  width: 70px;
  height: 36px;
  background: rgba(0, 168, 255, 0.2);
  border: 1px solid #0C70A4;
  text-align: center;
  line-height: 36px;
  font-weight: 400;
  font-size: 22px;
  color: #00A8FF;
  border-radius: 10px;
}

.separator_left_max {
  background: rgba(255, 204, 0, 0.2) !important;
  border: 1px solid #FFCC00 !important;
  font-weight: 400;
  font-size: 22px;
  color: #FFCC00 !important;
}


</style>